{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "onboarding",
  "title": "Onboarding",
  "description": "Per-domain self-serve onboarding state for the backoffice Day-1 setup surfaces (IX-3929). App-managed, not client-editable: set as the user claims, tests and installs. Established domains have no override and read as live.",
  "type": "object",
  "x-access": "staff",
  "properties": {
    "active": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "True while the domain is in self-serve onboarding (set when it is claimed). Established domains have no override and read as live."
    },
    "tested": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The agent has been tried in the playground."
    },
    "installed": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The Rose snippet has been installed / the site published. Once true, the account reads as live."
    },
    "brand_reviewed": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The Brand & tone screen has been reviewed and confirmed by the user."
    },
    "knowledge_reviewed": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The Knowledge screen has been reviewed and confirmed by the user (they checked what Rose read)."
    },
    "starter_reviewed": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The Suggested questions screen has been reviewed and confirmed by the user."
    },
    "cta_reviewed": {
      "type": "boolean",
      "default": false,
      "ui:hidden": true,
      "ui:description": "The CTAs screen has been reviewed and confirmed by the user."
    },
    "plan": {
      "type": "string",
      "enum": [
        "free",
        "starter",
        "growth"
      ],
      "ui:hidden": true,
      "ui:description": "Self-serve plan selected after provisioning. Free enables the lite knowledge tier; Starter and Growth enable the advanced tier."
    }
  },
  "default": {
    "active": false,
    "tested": false,
    "installed": false,
    "plan": "free"
  }
}
